import { useQuery } from "@tanstack/react-query";
import { Link, useLocation } from "react-router-dom";
import { BookOpenCheck } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { modulePermission } from "@/lib/roles";

// Shown on every page until the user has acknowledged all SOPs / NPI addenda visible to them.
export function SopUnreadBanner() {
  const { user } = useAuth(); const { pathname } = useLocation();
  const q = useQuery({ queryKey: ["sop-unread"], queryFn: async () => (await api.get("/sop/unread")).data, enabled: !!user && modulePermission(user, "sop") !== "none", refetchInterval: 300_000 });
  const d = q.data;
  if (!d?.count || pathname.startsWith("/sop")) return null;
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-md border border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-900" data-testid="sop-unread-banner">
      <BookOpenCheck size={16} className="shrink-0" />
      <span className="flex-1"><b>{d.count} SOP {d.count === 1 ? "document needs" : "documents need"} your acknowledgement</b>{d.addenda ? ` (${d.addenda} NPI CTP/CTQ addend${d.addenda === 1 ? "um" : "a"})` : ""}: {d.titles.slice(0, 3).join(", ")}{d.titles.length > 3 ? "…" : ""}</span>
      <Link to="/sop" className="pp-btn-primary h-8 px-3 text-xs" data-testid="sop-unread-banner-link">Read &amp; mark as read</Link>
    </div>
  );
}
